import type { ComponentProps } from "react";

type MarketingLinkProps = ComponentProps<"a"> & { href: string };

/** Public pages use document navigation so an initial click does not depend on
 * the Next client router, prefetched route data or a previous release's runtime.
 * Keep native link behavior, including fragments, new tabs and keyboard access.
 */
export default function MarketingLink(props: MarketingLinkProps) {
  return <a {...props} />;
}
